import { cn } from "@/utils/cn";

interface SpinnerProps {
  /** Diameter in px. */
  size?: number;
  className?: string;
}

/** Bordered-circle loading spinner — the animate-spin pattern used across the app. */
export function Spinner({ size = 24, className = "" }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        "animate-spin rounded-full border-2 border-border-light border-t-primary",
        className
      )}
      style={{ height: size, width: size }}
    />
  );
}
